import { render, staticRenderFns } from "./OTParcelListSubmit.vue?vue&type=template&id=86211300&"
import script from "./OTParcelListSubmit.vue?vue&type=script&lang=js&"
export * from "./OTParcelListSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports